import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { OTPResolver } from "validators/UserValidation";
import { TextInput } from "shared/Components/textInput";
import { globalVariables } from "helper/globalVariables";
import { Button } from "shared/Components/button";
import { useNavigate, useLocation } from "react-router-dom";
import AuthLayout from "shared/Components/authLayout";
import { client } from "helper/apolloConfig";
import { FORGET_PASSWORD_MUTATION, VERIFY_TOKEN_MUTATION } from "redux/features/passwordSlice/passwordGql";

const OTPScreen = () => {
  const location = useLocation();
  const email = location.state && location.state?.data;

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm({
    resolver: OTPResolver,
    defaultValues: { OTP: "" },
  });
  const [loading, setLoading] = useState();
  const [apiData, setApiData] = useState()
  const [modal, setModal] = useState({
    modalType:"",
    title: "",
    desc: "",
    type: "pending",
  })

  const navigate = useNavigate();

  const modalRef = useRef();

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      email: email.email,
      otp: values?.OTP,
    };
    try {
      const result = await client.mutate({
        mutation: VERIFY_TOKEN_MUTATION,
        variables: { data: payload },
      });

      if (result.data.verifyToken.access_token != null) {
        // OTP validated successfully - navigate directly to Reset Password page
        reset();
        navigate('/resetPassword', { state: { data: result.data.verifyToken } });
      }
      setLoading(false);
    }
    catch (error) {
      // Parse error message to show user-friendly text
      const errorMessage = error?.message || '';
      const lowerErrorMessage = errorMessage.toLowerCase();
      let displayMessage = errorMessage;
      let buttonLabel = "Try Again";
      let buttonAction = () => reset(); // Default: clear form and stay on page

      // Check if account is blocked
      if (lowerErrorMessage.includes('blocked') || lowerErrorMessage.includes('multiple consecutive login attempts')) {
        displayMessage = 'Your account has been temporarily blocked due to multiple failed attempts. Please contact support at k9scentgames.fun@gmail.com for assistance.';
        buttonLabel = "Go to Login";
        buttonAction = () => navigate('/login');
      }
      // Check if it's an incorrect OTP error
      else if (lowerErrorMessage.includes('maximum number of attempts') ||
          lowerErrorMessage.includes('invalid') ||
          lowerErrorMessage.includes('expired') ||
          lowerErrorMessage.includes('wrong') ||
          lowerErrorMessage.includes('verification code')) {
        displayMessage = 'Incorrect OTP code. Please try again or request a new code.';
      }

      modalRef.current.openModal();
      setModal({
        ...modal,
        title: globalVariables.error,
        desc: displayMessage,
        type: "pending",
        actionButton: {
          label: buttonLabel,
          onClick: buttonAction,
        },
      });
      setLoading(false);
    }


  };


  const onResendBtn = async (values) => {
    const payload = {
      email: email.email
    };
    try {
      const result = await client.mutate({
        mutation: FORGET_PASSWORD_MUTATION,
        variables: { data: payload },
      });

      if (result.data.forgetPassword.success) {
        setModal({
          modalType:"onResendBtn",
          title: globalVariables.otpCodeSuccess,
          desc: globalVariables.otpSuccessDescription,
          type: "success",
        });
        modalRef.current.openModal();

      }
      setLoading(false);
    }
    catch (error) {
      modalRef.current.openModal();
      setModal({
        ...modal,
        title: globalVariables.error,
        desc: error?.message,
        type: "pending",
      });
      setLoading(false);
    }
  };
  const onCloseModal = () => {
    if (modal?.type === "success") {
      navigate('/resetPassword', { state: { data: apiData } });
      reset();
    }
  };
  const handleCloseModal = () => {
    if (modal.modalType === "onResendBtn") {
      reset();
    } else {
      onCloseModal();
    }
  };


  return (
    <AuthLayout apiData={modal} ref={modalRef} onCloseModal={handleCloseModal} >
      <span className="pt-4 text-gray-900 font-semibold  text-3xl">
        {globalVariables.enterOTPCode}
      </span>
      <span className="pt-3 text-gray-500 font-regular text-base text-center w-[300px] md:w-[315px] lg:w-[340px]">
        {globalVariables.sentOTPInMail}
      </span>
      <div className="mt-6" />
      <form
        onSubmit={handleSubmit((d) => console.log("d===", d))}
        className="max-[400px]:w-[90%]"
      >
        <TextInput
          register={register}
          name="OTP"
          label={globalVariables.OTP}
          placeholder={globalVariables.enterOTPCode}
          errorMsg={errors.OTP?.message}
          type="text"
        />
        <div className="mt-6" />
        <Button
          label={globalVariables.sendOTPCode}
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
        />
      </form>
      <div className="mt-4" />
      <span className="text-sm text-gray-600 font-regular">
        {globalVariables.notReceiveCode}
        {/* <a href="/"> */}
        <span className="text-sm text-primary font-semibold cursor-pointer" onClick={onResendBtn}>{` ${globalVariables.resendCode}`}</span>
        {/* </a> */}
      </span>
    </AuthLayout>
  );
};

export default OTPScreen;
